import { Button, Group } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateDirectory } from 'src/Hooks/Mutations/useCreateDirectory';
import { trackEvent } from 'src/Services/Matomo';

import styles from './DocumentFolderSuggestions.module.scss';
import { Props } from './DocumentFolderSuggestions.types';

const SUGGESTED_FOLDERS = [
  'Administratif',
  'Factures & Devis',
  'Travaux & Entretien',
  'Assurances',
  'Fiscalité & Impôts',
  'Énergie & Fluides',
  'Photos & Souvenirs',
  'Comptes-rendus & AG',
];

const DocumentFolderSuggestions = ({ existingFolderNames, disabled = false }: Props) => {
  const { t } = useTranslation();
  const { mutate: createDirectory, isLoading } = useCreateDirectory();

  const existingSet = useMemo(
    () => new Set(existingFolderNames.map(n => n.trim().toLowerCase())),
    [existingFolderNames]
  );

  const availableSuggestions = useMemo(
    () => SUGGESTED_FOLDERS.filter(name => !existingSet.has(name.trim().toLowerCase())),
    [existingSet]
  );

  if (availableSuggestions.length === 0) {
    return null;
  }

  const handleClick = (name: string) => {
    trackEvent('Document', 'create_from_suggestion', name);
    createDirectory({ path: '/', name });
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {t('documentFolderSuggestions.title', 'Idées de dossiers à créer :')}
      </p>
      <Group gap="xs">
        {availableSuggestions.map(name => (
          <Button
            key={name}
            variant="light"
            radius="xl"
            size="xs"
            leftSection={<IconPlus size={14} stroke={2} />}
            onClick={() => handleClick(name)}
            disabled={disabled || isLoading}
          >
            {name}
          </Button>
        ))}
      </Group>
    </div>
  );
};

export default DocumentFolderSuggestions;
